var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74px",
    height: "67px",
    viewBox: "0 0 74 67",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3.0 Icons / Filled / Warning") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.32125,79.4520313 L75.67875,79.4520313 C81.64625,79.4520313 85.36625,72.9807813 82.3825,67.8270313 L53.20375,17.4132813 C50.22,12.2595312 42.78,12.2595312 39.79625,17.4132813 L10.6175,67.8270313 C7.63375,72.9807813 11.35375,79.4520313 17.32125,79.4520313 Z M46.5,52.3270312 C44.36875,52.3270312 42.625,50.5832812 42.625,48.4520312 L42.625,40.7020312 C42.625,38.5707812 44.36875,36.8270312 46.5,36.8270312 C48.63125,36.8270312 50.375,38.5707812 50.375,40.7020312 L50.375,48.4520312 C50.375,50.5832812 48.63125,52.3270312 46.5,52.3270312 Z M50.375,67.8270312 L42.625,67.8270312 L42.625,60.0770312 L50.375,60.0770312 L50.375,67.8270312 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fantasy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fantasy---Pre-Round---My-Team-(Selection-cap-limit)-[D]-",
    transform: "translate(-678.000000, -182.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7.0-Modals-/-Remove-Manager-[D]",
    transform: "translate(405.500000, 131.911599)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.0-Icons-/-Filled-/-Warning",
    transform: "translate(263.000000, 37.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon/alert/warning_24px",
    fill: "#303030",
    xlinkHref: "#path-1"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon-warning.e808a90eb5e974e7d8edd77acdf1bf77.svg";
export { ForwardRef as ReactComponent };